import { render, staticRenderFns } from "./ClinicPatientsList.vue?vue&type=template&id=e3962862&scoped=true"
import script from "./ClinicPatientsList.vue?vue&type=script&lang=js"
export * from "./ClinicPatientsList.vue?vue&type=script&lang=js"
import style0 from "./ClinicPatientsList.vue?vue&type=style&index=0&id=e3962862&prod&scoped=true&lang=css"
import style1 from "./ClinicPatientsList.vue?vue&type=style&index=1&id=e3962862&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3962862",
  null
  
)

export default component.exports